import './OrderManagement.scss'
import Home from './Home'
import { useSelector } from 'react-redux'
import TransferOrder from './Asset/TransferOrder'
import ApprovalOrder from './ApprovalOrder'
import CustomerMyOrder from './CustomerMyOrder'
import CreateNewRequisition from './Asset/TransferOrder/CreateNewRequisition'
import AssetApproval from './Asset/AssetApproval'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import PurchaseOrderMainContainer from './PurchaseOrderMainContainer/PurchaseOrderMainContainer'
import OrderDetailViewMainContainer from './OrderDetailViewMainContainer'
import AssetOrderDetailViewMainContainer from './Asset/AssetOrderDetailViewMainContainer/AssetOrderDetailViewMainContainer'
import BulkOrder from './BulkOrder'
import Reports from './Reports'
import Admin from './Admin'
import ApprovalDashboard from './ApprovalDashboard'

const OrderManagement = () => {

const activeNavigation = useSelector((state:any) => state.nav.nav)
const commonApiError = useSelector((state:any) => state.CommonErrorHandlerReducer?.commonApiError)
const navigate = useNavigate();

useEffect(()=>{
  if(commonApiError?.ErrorCode){
    navigate('/error-handling');
  }
},[commonApiError])

  const ActiveTabView = () => {
    switch(activeNavigation){
      case "Home":
          return <Home/>
      case "Customer My Orders":
        return <CustomerMyOrder/>
      case "PendingApprovalOrders":
        return <ApprovalOrder/>
      case "MyOrderDetail":
        return <OrderDetailViewMainContainer/>
      case "Fleet Processing":
        return <PurchaseOrderMainContainer/>
      case "Asset":
        return <TransferOrder/>
      case "TransferRequest":
        return <CreateNewRequisition/>
      case "AssetApproval":
        return <AssetApproval/>
      case "AssetOrderDetail":
        return <AssetOrderDetailViewMainContainer/>
      case "Bulk Orders":
        return <BulkOrder/>
      case "Reports":
        return <Reports/>
      case "Admin":
        return <Admin/>
      case "Approval":
        return <ApprovalDashboard/>
    default : break
    
  }
}

  return <>
       { ActiveTabView()}
    </>
}

export default OrderManagement
